var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicAutoLeveling = function SvgMicAutoLeveling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#mic-auto-leveling_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.623 17.189v-5.835c0-2.144 1.373-3.637 3.377-3.637 1.995 0 3.368 1.493 3.368 3.637v5.835c0 2.134-1.373 3.637-3.368 3.637-2.004 0-3.377-1.503-3.377-3.637Zm1.4 0c0 1.373.79 2.254 1.977 2.254 1.188 0 1.967-.881 1.967-2.254v-5.835c0-1.374-.78-2.255-1.967-2.255-1.188 0-1.976.881-1.976 2.255v5.835Zm-4.666.334V15.64a.69.69 0 0 1 .696-.696c.4 0 .705.306.705.696v1.827c0 3.164 2.06 5.26 5.242 5.26 3.173 0 5.232-2.096 5.232-5.26V15.64c0-.39.316-.696.706-.696a.69.69 0 0 1 .695.696v1.883c0 3.637-2.393 6.188-5.937 6.485v2.161h3.442c.39 0 .705.316.705.706 0 .39-.316.695-.705.695h-8.285a.697.697 0 0 1-.705-.695c0-.39.315-.706.705-.706h3.442v-2.161c-3.535-.297-5.938-2.848-5.938-6.485Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mic-auto-leveling_svg__a",
    x1: 0.405,
    y1: 0.81,
    x2: 0.405,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6584ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A43B8"
  })))));
};
export default SvgMicAutoLeveling;